import React, { Component, Fragment } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { NotificationContainer } from 'react-notifications';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-notifications/lib/notifications.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-data-grid/dist/react-data-grid.css';
import 'font-awesome/css/font-awesome.css';
import '../../scss/app.scss';
import Router from './Router';
import store from './store';
import ScrollToTop from './ScrollToTop';
import { verifyUserToken } from '../../redux/actions/loginActions';
import { createSuccessMessage } from '../../helpers/notification';

class App extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      loaded: false,
    };
  }

  componentDidMount() {
    try {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });

      console.log('Complete Cache Cleared');
    } catch (e) {
      console.error(e);
    }

    window.addEventListener('load', () => {
      this.setState({ loading: false });
      setTimeout(() => this.setState({ loaded: true }), 500);
    });
    const { location: { pathname: path } } = window;
    if (!(path === '' || path === '/' || path === '/log_in')) {
      store.dispatch(verifyUserToken({
        onError: () => {
          createSuccessMessage('Error');
          window.location.href = ('/');
        },
      }));
    }
  }

  render() {
    const { loaded, loading } = this.state;
    return (
      <Provider store={store}>
        <BrowserRouter>
          <ScrollToTop>
            <Fragment>
              {!loaded
                && (
                  <div className={`load${loading ? '' : ' loaded'}`}>
                    <div className="load__icon-wrap">
                      <svg className="load__icon">
                        <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                      </svg>
                    </div>
                  </div>
                )
              }
              <div>
                <Router props={this.props} />
                <NotificationContainer />
              </div>
            </Fragment>
          </ScrollToTop>
        </BrowserRouter>
      </Provider>
    );
  }
}

// Condicionalmente usa hot(module)(App) solo en desarrollo
const isDevelopment = process.env.NODE_ENV === 'development';
export default isDevelopment ? hot(module)(App) : App;
